module.exports = __webpack_public_path__ + "static/SFMono-Medium-02bbb63875ebdbf463e764bb3d8ff190.ttf";